import { invokeApi } from "../../utils/invokeApi/invokeApi";

export const get_payment_request_list_for_client = async (
  status = "pending"
) => {
  const requestObj = {
    path: `api/payment_request/get_payment_request_against_client?status=${status}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_payment_request_details = async (id) => {
  const requestObj = {
    path: `api/payment_request/detail_payment_request/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_admin_stripe_setting = async () => {
  const requestObj = {
    path: `api/setting/get_stripe_setting`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const upgrade_plan = async (data) => {
  const requestObj = {
    path: `api/app_api/upgrade_plan`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const paymentrequest_onetime_payment = async (data) => {
  const requestObj = {
    path: `api/client/payment-request/pay-onetime`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const paymentrequest_confirm_onetime_payment = async (data) => {
  const requestObj = {
    path: `api/client/payment-request/change-status`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const paymentrequest_recurring_payment = async (data) => {
  const requestObj = {
    path: `api/client/payment-request/pay`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const paymentrequest_confirm_recurring_payment = async (data) => {
  const requestObj = {
    path: `api/client/payment-request/confirm-incomplete`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
